import { z } from "zod";

/**
 * A transformed file object type that works with the file upload service within
 * the Data Platform API
 * @see {@link https://admin-staging.dataplatform.validere.xyz/docs#/Files}
 */
export const FileUploadedSchema = z
  .object({
    ref: z.string(),
    name: z.string(),
  })
  .describe("Represents a file uploaded to the Data Platform API");

export type FileUploadedType = z.infer<typeof FileUploadedSchema>;

export const FileScanStatus = {
  SAFE: "safe",
  UNSAFE: "unsafe",
  PENDING: "pending",
  SCANNING: "scanning",
  UNKNOWN: "unknown",
} as const;
export type FileScanStatusType =
  (typeof FileScanStatus)[keyof typeof FileScanStatus];

export const TERMINAL_FILE_SCAN_STATUSES = [
  FileScanStatus.SAFE,
  FileScanStatus.UNSAFE,
] as const satisfies readonly FileScanStatusType[];

export const FileDownloadMetaSchema = z
  .object({
    file_id: z.string(),
    file_scan_status: z.nativeEnum(FileScanStatus),
    uri: z.string().optional(),
  })
  .describe("Represents file download metadata from the Data Platform API");

export type FileDownloadMetaType = z.infer<typeof FileDownloadMetaSchema>;
